const authorizedDealer = {
  authorizedDealer: {
    dealerId: '認定下請業者',
    city: '市区町村',
    state: '都道府県',
    country: '国',
    noDealer: '** 使用可能な認定下請業者はありません **',
    heading: '認定下請業者',
    addDealerButton: '+認定下請業者を追加する',
    cancel: 'キャンセル',
    addSubcontractor: '下請業者を追加する',
    searchContractor: '下請業者を検索する',
    show: '表示',
    to: '～',
    of: '/',
    delete: '削除',
    name: '名称',
    enabled: '有効',
    disabled: '無効',
    status: 'ステータス',
    footer: '認定下請業者'
  }
};

export default authorizedDealer;
